<template>
  <div>
    <th-login />
  </div>
</template>
<script>
import ThLogin from '@/components/Auth/Login/index.vue'
export default {
  components: {
    ThLogin,
  },
}
</script>
